import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import * as actions from './redux/actions';
import { connect } from 'react-redux';
import { drapcodeIcon } from '../../common/custom/icon-library';
import TooltipInfo from '../../common/docs/TooltipInfo';
import { description } from '../../common/utils/event_constants';
import ParentContentCard from '../common/ParentContentCard';
import { checkPageSnapPermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';
import showAlert from '../../common/utils/alert';
import { PAGE_SNAPSHOT } from 'drapcode-constant';
import ParentDocCard from '../common/ParentDocCard';
import { pageSnapshotText } from '../../common/docs/content';
import { isProjectReadOnly } from '../../common/utils/api_utils';

class ListPageSnapshots extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetailAppSetting({ projectId, version });
    actions.getPermissionFlags({ projectId });
    actions.loadPageSnapshots({ projectId, version });
  }

  handlePageSnapshotDelete = (uuid) => {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    const preConfirm = () => {
      actions.deletePageSnapshot({ projectId, version, uuid });
    };
    showAlert('Are you sure, you want to delete it?', preConfirm, 'Yes,delete it! ');
  };
  showSnapshots = () => {
    const { appSetting } = this.props;
    const { projectDetail, permissionFlags } = appSetting;
    if (!projectDetail) {
      return '';
    }
    const { uuid: projectId } = projectDetail;
    const isReadOnly = isProjectReadOnly(projectId);
    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }

    const deleteFlag = permissionsArray.includes(PAGE_SNAPSHOT);
    const { pageSnapshots } = appSetting;
    if (!pageSnapshots.length) {
      return (
        <tr>
          <td className="align-middle"># </td>
          <td className="align-middle"> Page Snapshots not found!</td>
          <td className="text-right"></td>
        </tr>
      );
    }
    return pageSnapshots
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      .map((pageSnapshots, index) => (
        <tr key={pageSnapshots.uuid} className="text-left">
          <td className="align-middle">{index + 1}</td>
          <td className="align-middle">{pageSnapshots.name}</td>
          <td className="text-right">
            <button
              className="btn btn-xs btn-theme-delete"
              onClick={() =>
                deleteFlag && !isReadOnly
                  ? this.handlePageSnapshotDelete(pageSnapshots.uuid)
                  : undefined
              }
              title={isReadOnly ? 'Read-Only Mode' : `Delete ${pageSnapshots.name}`}
              style={{
                cursor: deleteFlag && !isReadOnly ? 'pointer' : 'not-allowed',
                opacity: !isReadOnly ? 1 : 0.5,
              }}
              disabled={isReadOnly}
            >
              <i className={`wb ${drapcodeIcon('delete')}`}></i> Delete
              {deleteFlag ? null : (
                <>
                  &nbsp;
                  <TooltipInfo
                    title={description}
                    headerText={`Permission Disabled!`}
                    showHeader={true}
                    showArrow={true}
                  />
                </>
              )}
            </button>
          </td>
        </tr>
      ));
  };

  render() {
    const isAllowed = checkPageSnapPermission();
    if (!isAllowed) {
      return <PermissionDenied message="Page Snapshots" />;
    }

    const { appSetting } = this.props;
    const { projectDetail } = appSetting;
    if (!projectDetail) {
      return '';
    }

    return (
      <CommonPageComponent>
        <AppSettingsNav activeTab={'pageSnapshot'} projectDetail={projectDetail} />

        <ParentContentCard bgColor="drapcode-violet" icon="list" title="Page Snapshots">
          <div className="row mx-auto h-70 table-responsive">
            <table className="table table-bordered table-hover table-sm table-word-break">
              <thead>
                <tr>
                  <th>#</th>
                  <th className="w-90">Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>{this.showSnapshots()}</tbody>
            </table>
          </div>
        </ParentContentCard>
        <ParentDocCard>
          <h5>
            <b>About Page Snapshots</b>
          </h5>
          <p>{pageSnapshotText}</p>
          <br />
        </ParentDocCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ListPageSnapshots);
